import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "project-index" }
const _hoisted_2 = { class: "grid-container" }
const _hoisted_3 = { class: "grid-x button-group" }
const _hoisted_4 = { class: "cell small-6 medium-3" }
const _hoisted_5 = { class: "cell small-6 medium-3" }
const _hoisted_6 = { class: "cell small-6 medium-3" }
const _hoisted_7 = { class: "cell small-6 medium-3" }
const _hoisted_8 = { class: "grid-container data-table-container" }
const _hoisted_9 = { class: "grid-x data-table-grid" }

import { h, reactive, ref } from 'vue'
import { NCard, NButton, NDataTable, NTag, NFlex, NModal, NIcon, NEmpty } from 'naive-ui'

import DetailsCard from "@/components/utils/DetailsCard.vue";

import { TrashAltRegular, EditRegular, InfoCircle, Exclamation as ExclamationIcon } from '@vicons/fa'

import { useProjectIndexStore } from "@/stores/projects/index.store";
import { useProjectShowStore } from "@/stores/projects/show.store";
import { useProjectDeleteStore } from "@/stores/projects/delete.store";
import { useRouter } from "vue-router";

import type { DataTableColumns } from 'naive-ui'

type ProjectRowData = {
  key: number
  role_title: string
  created_at: string
  status: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectsIndexView',
  setup(__props) {

const projectStore = useProjectIndexStore()
const projectShowStore = useProjectShowStore()
const projectDeleteStore = useProjectDeleteStore()

const router = useRouter()
const activeDeleteItem = reactive<{ id: number, title: string | null }>({
  id: 0,
  title: null
})

const showDetailsCard = ref<boolean>(false)
const showDeleteModal = ref<boolean>(false)

projectStore.listProjects()

const detail = (rowData: ProjectRowData) => {
  showDetailsCard.value = true
  projectShowStore.getProjectInfo(rowData.key)
}
const edit = (rowData: ProjectRowData) => {
  router.push({ name: 'client-project-edit', params: { id: rowData.key } })
}

const remove = (rowData: ProjectRowData) => {
  activeDeleteItem.id = rowData.key
  activeDeleteItem.title = rowData.role_title
  showDeleteModal.value = true
}

const actions = [
  {
    name: 'Detail',
    icon: InfoCircle,
    action: detail,
    redirect: false
  },
  {
    name: 'Edit',
    icon: EditRegular,
    action: edit,
    redirect: false
  },
  {
    name: 'Delete',
    icon: TrashAltRegular,
    action: remove,
    redirect: false
  },
]

const createColumns = (): DataTableColumns<ProjectRowData> => {
  return [
    {
      title: 'Role title',
      key: 'role_title',
      sorter: 'default',
      className: 'text-w-bold'
    },
    {
      title: 'Date',
      key: 'created_at',
      sorter: 'default',
      className: 'text-pink',
      render (row) {
        const date = new Date(row.created_at)
        return date.toLocaleDateString()
      }
    },
    {
      title: 'Status',
      key: 'status',
      render (row) {
        return h(
          NTag,
          {
            style: {
              marginRight: '6px',
              textTransform: 'capitalize'
            },
            type: 'info',
            bordered: false
          },
          {
            default: () => row.status
          }
        )
      }
    },
    {
      title: 'Action',
      key: 'actions',
      render (row) {
        const buttons = actions.map((action) => {
          return h(
            NButton,
            {
              size: 'medium',
              circle: true,
              quaternary: true,
              onClick: () => action.action(row)
            },
            { icon: () => h(action.icon) }
          )
        })

        return h(
          NFlex,
          {
            size: 'small'
          },
          {
            default : () => {
              return buttons
            }
          }
        )
      }
    }
  ]
}

const columns = createColumns();

const detailsDataStructure = [
  {
    label: 'Role title',
    key: 'role_title',
    type: 'string',
  },
  {
    label: 'Years of experience',
    key: 'years_of_experience',
    type: 'string',
  },
  {
    label: 'Budgeted hourly rate (USD)',
    key: 'usd_hourly_rate',
    type: 'string',
  },
  {
    label: 'Job description',
    key: 'job_description',
    type: 'string',
  },
  {
    label: 'Job description link',
    key: 'job_description_link',
    type: 'link',
  },
  {
    label: 'Main Skills',
    key: 'skills',
    type: 'object',
  },
  {
    label: 'Secondary Skills',
    key: 'complementary_skills',
    type: 'object',
  },
]

const confirmDelete = async () => {
  const response = await projectDeleteStore.deleteProject(activeDeleteItem.id)

  if(response.ok) {
    showDeleteModal.value = false

    projectStore.listProjects()
  }
}

const cancelDelete = () => {
  showDeleteModal.value = false

  setTimeout(() => {
    activeDeleteItem.id = 0
    activeDeleteItem.title = null
  }, 1000)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(NCard), {
        size: "huge",
        title: "Projects",
        bordered: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(NButton), {
                type: "primary",
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" ACTIVE PROJECTS ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(NButton), {
                type: "primary",
                size: "large",
                disabled: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" CLOSED PROJECTS ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(NButton), {
                type: "primary",
                size: "large",
                disabled: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" ALL PROJECTS ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_router_link, { to: { name: 'client-project-create' } }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NButton), { size: "large" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" + NEW PROJECT ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: _normalizeClass(["cell data-table", showDetailsCard.value ? 'small-8' : 'small-12'])
        }, [
          _createVNode(_unref(NCard), {
            size: "huge",
            title: "Active Projects",
            bordered: false
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NDataTable), {
                size: "large",
                bordered: false,
                columns: _unref(columns),
                data: _unref(projectStore).projects,
                pagination: { pageSize: 10 }
              }, {
                empty: _withCtx(() => [
                  _createVNode(_unref(NEmpty), { description: "No projects registered" })
                ]),
                _: 1
              }, 8, ["columns", "data"])
            ]),
            _: 1
          })
        ], 2),
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["cell card-container", { 'small-4': showDetailsCard.value }])
        }, [
          _createVNode(DetailsCard, {
            title: "Project Details",
            "details-structure": detailsDataStructure,
            data: _unref(projectShowStore).project,
            onCloseCard: _cache[0] || (_cache[0] = ($event: any) => (showDetailsCard.value = false))
          }, null, 8, ["data"])
        ], 2), [
          [_vShow, showDetailsCard.value]
        ])
      ])
    ]),
    _createVNode(_unref(NModal), {
      show: showDeleteModal.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((showDeleteModal).value = $event)),
      preset: "dialog",
      title: `Delete "${activeDeleteItem.title}"`,
      content: "Are you sure?",
      "positive-text": "Delete",
      "negative-text": "Cancel",
      loading: _unref(projectDeleteStore).status === 0,
      onPositiveClick: confirmDelete,
      onNegativeClick: cancelDelete
    }, {
      icon: _withCtx(() => [
        _createVNode(_unref(NIcon), null, {
          default: _withCtx(() => [
            _createVNode(_unref(ExclamationIcon))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show", "title", "loading"])
  ]))
}
}

})